module.exports = __webpack_public_path__ + "img/thumbnail_NorthIslandBrownKiwi_j_piebald.82f88a36.png";